import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({

    st1: {
        fill: '#0078FF',
    },

    st2: {
        fill: '#FFFFFF',
    },

    st3: {
    },

    st4: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st5: {
        fill: '#010134',
    },

}));
